/* eslint-disable max-len */
import { createSvgIcon } from "../utils";

const NoticeSuccess = createSvgIcon(
    <>
        <path d="M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20z" />
        <path
            d="M28.707 13.293a1 1 0 010 1.414l-12 12a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L16 24.586l11.293-11.293a1 1 0 011.414 0z"
            fill="#fff"
        />
    </>,
    "NoticeSuccess",
);

export default NoticeSuccess;
